import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsRoutingModule } from "./forms-routing.module";
import { SharedModule } from "../../shared/shared.module";
import { FormsComponent } from './forms.component';

@NgModule({
  imports: [
    CommonModule,
    FormsRoutingModule,
    SharedModule,
  ],
  declarations: [FormsComponent]
})
export class FormsModule { }



// WEBPACK FOOTER //
// ./src/app/components/forms/forms.module.ts